<template>
    <!-- 车辆管理 -->
    <div class="public_Spacing carManagement">
        <div class="pulbic_oparetionBlock">
            <div class="public_criteriaRange">
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">车牌号：</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <el-input type="text" placeholder="请输入" v-model="ORMTB609CA01" :clearable="true" />
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">联系人：</label>
                    <div class="el-select public_optionSty">
                        <el-select v-model="ORMTB410ID" placeholder="请选择" filterable :clearable="true">
                            <el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410NAME"
                                :value="item.ORMTB410ID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="public_operatArea">
                <div class="public_operatBtn" style="margin-left: 0;">
                    <button @click="queryClick" class="public_saleWater_chaxun pulic_cursor">
                        <i class="iconfont icon-chaxun"></i>查询
                    </button>
                    <button v-shiroHiden="solelist" id="新增" @click="newlyAdd"
                        class="public_saleWater_xinzeng pulic_cursor">
                        <i class="iconfont icon-tianjia1"></i>新增
                    </button>
                </div>
            </div>
        </div>
        <div class="bcarManagement-table pulbic_table_container">
            <el-table :data="tableData" style="width: 100%;" max-height="90%" stripe
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column label="车牌号" prop="ormtb609CA01"> </el-table-column>
                <el-table-column label="联系人" prop="ormtb410NAME"> </el-table-column>
                <el-table-column label="联系电话" prop="ormtb609CA02"> </el-table-column>
                <el-table-column label="vin码" prop="ormtb609CA03"> </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="modify(scope.row)" v-shiroHiden="solelist" id="修改"
                            class="public_icon_xiugai public_icon_width  public_icon_margin" type="primary"
                            size="small">修改</el-button>
                        <el-button v-shiroHiden="solelist" id="删除" @click="deleteClick(scope.row)"
                            class="public_icon_jinyong public_icon_width" type="primary" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>

        <!-- 新增 -->
        <div class="public-dialog">
            <el-dialog title="新增车辆信息" :visible.sync="billOperationAdd" width="40%" :closeOnClickModal="false">
                <div class="systemCodePC-add-code">
                    <div class="systemCodePC-add-code-table">
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">车牌号</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" class="car-number-add" v-model="carNumberAdd"
                                    placeholder="请输入车牌号"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">账号</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" maxlength="11" v-model="carNameAdd" placeholder="请输入账号"
                                    @input="carNameAdd = carNameAdd.replace(/[^\d]/g, '')"
                                    @change="getCustomerName"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">昵称</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" v-model="carPhoneAdd" disabled placeholder="请先输入账号"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">vin码</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" v-model="vinCode" placeholder="请输入vin码"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                    </div>
                    <div class="systemCodePC-add-code-btn">
                        <el-button type="primary" @click="preservationAdd">保存</el-button>
                        <el-button type="warning" @click="cancelAdd">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 修改 -->
        <div class="public-dialog">
            <el-dialog title="修改车辆信息" :visible.sync="billOperationDetails" width="40%" :closeOnClickModal="false">
                <div class="systemCodePC-add-code">
                    <div class="systemCodePC-add-code-table">
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">车牌号</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" class="car-number-add" v-model="carNumberModify"
                                    placeholder="请输入车牌号"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">账号</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input maxlength="11" type="text" v-model="carNameModify" disabled></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text"></div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">昵称</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input maxlength="11" type="text" v-model="carPhoneModify" disabled
                                    @input="carPhoneModify = carPhoneModify.replace(/[^\d]/g, '')"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text"></div>
                        </div>
                        <div class="systemCodePC-add-code-table-li">
                            <div class="systemCodePC-add-code-table-li-name">vin码</div>
                            <div class="systemCodePC-add-code-table-li-ipt">
                                <el-input type="text" v-model="vinCodeModify" placeholder="请输入vin码"></el-input>
                            </div>
                            <div class="systemCodePC-add-code-table-li-text">*必填*</div>
                        </div>
                    </div>
                    <div class="systemCodePC-add-code-btn">
                        <el-button type="primary" @click="preservationModify">保存</el-button>
                        <el-button type="warning" @click="cancelModify">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userobj: this.$store.state.uobj, //登陆缓存--用户信息
            carNum: '',
            billOperationAdd: false,
            billOperationDetails: false,
            tableData: [],
            customerManagementList: [],
            customerManagementPhoneList: [],
            carNumberAdd: '',
            carNameAdd: '',
            carPhoneAdd: '',
            tareIptAdd: '',
            judgeAdd: 0, //判断校验车辆，车辆类型是新增还是修改--新增
            maxl: '',
            // 修改
            SETTB402ID: '', //车辆id
            carNumberModify: '',
            carNameModify: '',
            carPhoneModify: '',
            tareIptModify: '',
            edCarNameModify: '',
            edCarPhoneModify: '',
            carID: '', //一二级客户车辆id
            judgeModify: 1, //判断校验车辆，车辆类型是新增还是修改--修改
            judgeCarNumMo: '', //判断修改时当前输入的车牌号是否和未修改之前的一样--修改
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',

            solelist: [],

            ORMTB609CA01: '',//车牌号
            customerOptions: [],
            vinCode: '',//车辆vin码
            ORMTB410ID: '',//客户ID
            vinCodeModify: '',
            ormtb609ID: '',//列表ID
            carPhoneAddId: '',//昵称对应的用户ID
            carPhoneModifyId: '',//修改昵称对应的用户ID
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        var path = this.$route.path
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
        this.userobj = this.$store.state.uobj
        // 赋值，缓存销毁
        console.log('currentUrl', this.currentUrl)
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        sessionStorage.removeItem(this.currentUrl)
        if (this.historyInfo != null && this.historyInfo != '') {
            this.init()
        }
    },
    mounted() {
        this.enterprise0ptions();
        this.pageList();
    },
    // 存储数据
    beforeDestroy() {
        var obj = {
            carNum: this.carNum, //车牌号
            currentPage: this.currentPage, //当前页数
            pageMo: this.pageMo, //页码
            limitMo: this.limitMo, //每页条数
        }
        sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
    },
    methods: {
        //新增输入账号获取昵称
        getCustomerName(value) {
            var regP = /^1[3-9][0-9]{9}$/
            if (!regP.test(value)) {
                return this.$message({
                    message: '账号格式不正确，请检查!',
                    type: 'error',
                })
            }
            this.axios.post('/orm/ormtb410/selectOrmtb410ByPhone', { ORMTB410CA02: value }).then(res => {
                if (res.data.code == 200) {
                    this.carPhoneAdd = res.data.data.ORMTB410CA10;
                    this.carPhoneAddId = res.data.data.ORMTB410ID;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        /// 客户--查询
        enterprise0ptions() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {}
            var url = '/orm/ormtb609/selectExistOrmtb609'
            this.axios.post(url, postData).then(res => {
                loading.close()
                if (res.data.code == 200) {
                    // 客户
                    this.customerOptions = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            }).catch(error => {
                loading.close()
            })
        },
        //初始化数据
        init() {
            this.carNum = this.historyInfo.carNum
            this.currentPage = this.historyInfo.currentPage
            this.pageMo = this.historyInfo.pageMo
            this.limitMo = this.historyInfo.limitMo
        },
        // 删除
        deleteClick(row) {
            var postData = {
                ORMTB609ID: row.ormtb609ID,
            }
            var url = '/orm/ormtb609/deleteOrmtb609'
            this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.axios.post(url, postData).then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {
                        this.pageList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!',
                        })
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
            })
        },
        // 新增保存
        preservationAdd() {
            // var regC = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/
            var regC = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]$/;
            var regP = /^1[3-9][0-9]{9}$/
            if (!this.carNumberAdd.trim()) {
                return this.$message({
                    message: '车牌号不能为空!',
                    type: 'error',
                })
            } else {
                if (!regC.test(this.carNumberAdd)) {
                    return this.$message({
                        message: '车牌号格式不正确，请检查!',
                        type: 'error',
                    })
                }
            }
            if (!this.carNameAdd) {
                return this.$message({
                    message: '账号不能为空!',
                    type: 'error',
                })
            } else {
                if (!regP.test(this.carNameAdd)) {
                    return this.$message({
                        message: '账号格式不正确，请检查!',
                        type: 'error',
                    })
                }
            }
            if (!this.carPhoneAdd) {
                return this.$message({
                    message: '昵称不能为空!',
                    type: 'error',
                })
            }
            if (!this.vinCode.trim()) {
                return this.$message({
                    message: 'vin码不能为空!',
                    type: 'error',
                })
            } else {
                if (this.vinCode.length != 17) {
                    return this.$message({
                        message: 'vin码格式不正确!',
                        type: 'error',
                    })
                }
            }
            this.postAdd()
        },
        // 新增调用接口
        postAdd() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB609CA01: this.carNumberAdd, //车牌号
                ORMTB410ID: this.carPhoneAddId, //昵称
                ORMTB609CA02: this.carNameAdd, //账号
                ORMTB609CA03: this.vinCode, //VIN码
            }
            var url = '/orm/ormtb609/insertOrmtb609'
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '新增成功',
                            type: 'success',
                        })
                        this.billOperationAdd = false
                        this.pageList();
                        this.enterprise0ptions();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 新增取消
        cancelAdd() {
            this.billOperationAdd = false
        },
        // 新增
        newlyAdd() {
            this.billOperationAdd = true
            this.carNumberAdd = '' //车牌号
            this.carNameAdd = '' //姓名
            this.carPhoneAdd = '' //电话
            this.vinCode = ''
        },
        // 修改保存
        preservationModify() {
            // var regC = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/
            var regC =
                /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]$/;
            if (!this.carNumberModify.trim()) {
                return this.$message({
                    message: '车牌号不能为空!',
                    type: 'error',
                })
            } else {
                if (!regC.test(this.carNumberModify)) {
                    return this.$message({
                        message: '车牌号格式不正确，请检查!',
                        type: 'error',
                    })
                }
            }
            if (!this.vinCodeModify.trim()) {
                return this.$message({
                    message: 'vin码不能为空!',
                    type: 'error',
                })
            } else {
                if (this.vinCodeModify.length != 17) {
                    return this.$message({
                        message: 'vin码格式不正确!',
                        type: 'error',
                    })
                }
            }
            this.modifyPost()
        },
        modifyPost() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB609ID: this.ormtb609ID, //id
                ORMTB609CA01: this.carNumberModify, //车牌号
                ORMTB410ID: this.carPhoneModifyId, //昵称ID
                ORMTB609CA02: this.carNameModify, //账号
                ORMTB609CA03: this.vinCodeModify, //vin码
            }
            var url = '/orm/ormtb609/updateOrmtb609'
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        this.billOperationDetails = false
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                        })
                        this.pageList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 修改取消
        cancelModify() {
            this.billOperationDetails = false
        },
        // 修改
        modify(row) {
            this.billOperationDetails = true
            this.carNumberModify = row.ormtb609CA01//车牌号
            this.carNameModify = row.ormtb609CA02 //账号
            this.carPhoneModify = row.ormtb410NAME //昵称
            this.carPhoneModifyId = row.ormtb410ID //昵称id
            this.ormtb609ID = row.ormtb609ID //列表id
            this.vinCodeModify = row.ormtb609CA03 || '' //vin码
        },
        // 查询
        queryClick() {
            this.pageMo = 1
            this.currentPage =1;
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB609CA01: this.ORMTB609CA01, //车牌号
                ORMTB410ID: this.ORMTB410ID, //车主姓名
                page: this.pageMo,
                limit: this.limitMo,
            }

            this.tableData = []
            var url = '/orm/ormtb609/selectPageOrmtb609'
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        this.tableData = res.data.data
                        this.pagingPageMo = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
        clearNoNum(value) {
            value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
            value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
            value = value
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.')
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
            if (value.indexOf('.') < 0 && value != '') {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value)
            }
            return value
        },
    },
}
</script>

<style scoped>
.carManagement {
    background: #f3f3f3;
}

.bcarManagement-table {
    padding: 30px 20px 0;
}

.test111:active {
    background-color: red !important;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

/* 弹框 */
.systemCodePC-add-code {
    padding: 0 20px;
}

.systemCodePC-add-code-table-li {
    display: flex;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.systemCodePC-add-code-table-li>div {
    border: 1px solid #cdcdcd;
    border-top: none;
}

.systemCodePC-add-code-table-li:first-child>div {
    border-top: 1px solid #cdcdcd;
}

.systemCodePC-add-code-table-li>div:first-child {
    border-right: none;
}

.systemCodePC-add-code-table-li>div:last-child {
    border: none;
}

.systemCodePC-add-code-table-li-name {
    flex: 1;
    background: rgba(240, 252, 255, 1);
}

.systemCodePC-add-code-table-li-ipt {
    flex: 1;
}

.systemCodePC-add-code-table-li-ipt input {
    height: 100%;
    width: 100%;
    border: none;
    vertical-align: top;
    box-sizing: border-box;
    text-align: center;
}

.systemCodePC-add-code-table-li-ipt input:focus {
    outline: none;
}

.systemCodePC-add-code-table-li-text {
    flex: 0.3;
    color: #ff4d35;
}

.systemCodePC-add-code-btn {
    margin-top: 20px;
    text-align: center;
}

.systemCodePC-pagesize {
    text-align: right;
    margin-top: 20px;
}

/deep/.el-input.is-disabled .el-input__inner {
    background: transparent !important;
}

/deep/.public_optionSty .el-input input {
    width: 200px !important;
}
</style>
<style>
.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.itemMsg {
    padding: 0 10px;
}

.demo-table-expand .item-lxxx .el-form-item__content {
    width: 500px;
}
</style>
